import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
import { useMutation } from "react-apollo";
import { Button, Icon } from "rbx";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Confirmation } from "../modals";
import { ModalContext } from "../ModalProvider";
import { ourToast as toast } from "../../utils";

function DeleteButton({
  mutation,
  variables,
  refetchQueries,
  size,
  onComplete,
  confirmModalMessage,
  warningMessage,
  showLabel,
  isDispatcher
}) {
  const [isLoading, setLoading] = useState(false);
  const [performDelete, { loading }] = useMutation(mutation, {
    refetchQueries
  });

  const { setModalOpen } = useContext(ModalContext);
  const doDelete = async () => {
    try {
      if (warningMessage) {
        toast.warning(warningMessage);
      } else if (confirmModalMessage) {
        setModalOpen(
          true,
          <Confirmation
            message={confirmModalMessage}
            onConfirm={async () => {
              setLoading(true);
              await setModalOpen(false);
              await performDelete({
                variables
              });
              await toast.success("Deleted successfully.");
              await onComplete();
              setLoading(false);
            }}
          />
        );
      } else {
        setLoading(true);
        await performDelete({
          variables
        });
        await toast.success("Deleted successfully.");
        await onComplete();
        setLoading(false);
      }
    } catch (err) {
      console.log(err.message);
      toast.error("Error deleting.");
    }
  };
  return (
    <Button
      color={showLabel ? "danger" : ""}
      disabled={isDispatcher}
      size={size}
      state={loading || isLoading ? "loading" : ""}
      type="button"
      onClick={doDelete}
    >
      <Icon>
        <FontAwesomeIcon icon="trash" />
      </Icon>
      {showLabel && <span>Delete</span>}
    </Button>
  );
}

DeleteButton.propTypes = {
  mutation: PropTypes.object,
  variables: PropTypes.object,
  onComplete: PropTypes.func,
  refetchQueries: PropTypes.array,
  size: PropTypes.string,
  confirmModalMessage: PropTypes.string,
  warningMessage: PropTypes.string,
  showLabel: PropTypes.bool,
  isDispatcher: PropTypes.bool
};

DeleteButton.defaultProps = {
  size: "normal",
  showLabel: true
};
export default DeleteButton;
